import type { IActivity } from '@/interfaces/IActivity'
import { JobTask } from './jobs'
import type { IJobTask } from '@/interfaces'
import AppUser from './AppUser'
import type { IAppUser } from '@/interfaces/app-user/IAppUser'
import { JobType } from '@/enum'

class Activity implements IActivity {
  title: string
  description: string
  jobTaskId: string
  jobTask: IJobTask
  timestamp: string
  userId: string
  user: IAppUser
  type?: JobType
  createdAt: string

  constructor(activity: any) {
    this.title = activity?.title
    this.description = activity?.description
    this.jobTaskId = activity?.jobTaskId
    this.jobTask = new JobTask(activity?.jobTask)
    this.timestamp = activity?.timestamp
    this.userId = activity?.userId
    this.user = new AppUser(activity?.user)
    this.createdAt = activity?.createdAt
    this.type = activity?.jobTask?.job?.type || JobType.GENERAL
  }
}

export default Activity
